import type { ReactNode } from 'react';

export const symbol_mark_chat_read: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m701-245 156-156q9-9 21-8.5t21.39 9.5q8.61 9 8.61 21t-9 21L722-181q-9 9-21 9t-21-9l-92-92q-9-9-9-21t9-21q9-9 21-8.5t21 8.5l71 70Zm-461 5L131-131q-14 14-32.5 6.34Q80-132.31 80-152v-668q0-24 18-42t42-18h680q24 0 42 18t18 42v280q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-280H140v600l74-80h246q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H240Zm-100-60v-520 520Z"
		/>
	</svg>
);
